"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.localText = void 0;
exports.localText = {
    tagName: 'Tag name',
    tagValue: 'Tag value',
    addName: 'Add name',
    addValue: 'Add value',
    nameAlreadyTakenError: 'Name already taken',
    helperText: 'Submit with enter',
    addTag: 'Add Tag',
};
